//on prem - server - dns

export const environment = {
  production: false,
  tradeApiUrl: 'https://api.kite.trade',
  apiVersion: 3,
  tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
  accessToken: 'XXXXXXXXXXXX',
  apiKey: 'XXXXXXXXXXXX',
  pixelTradeApi: 'https://spot.gammasoftware.in/api',
  authApiURI: 'https://spot.gammasoftware.in/Identity',
  client_id: 'gammaspottardeui',
  appURI: 'https://spot.gammasoftware.in/app',
  authCallback: '/account/auth-callback',
  post_logout_redirect_uri: '/account/login',
  response_type: 'id_token token',
  scope: 'openid profile email pixeltradeapi.read',
  silent_redirect_uri: '/silent-refresh.html'
};
//on prem - local - dns

// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://spot.gammasoftware.in/api',
//   authApiURI: 'https://spot.gammasoftware.in/Identity',
//   client_id: 'gammaspottardeuilocal',
//   appURI: 'http://localhost:4200',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };





// local

// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://pixeltrade.local/api',
//   authApiURI: 'https://pixeltrade.local/Identity',
//   client_id: 'pixeltradeuilocal',
//   appURI: 'http://localhost:4200',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };


// local - on prem

// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://localhost/api',
//   authApiURI: 'https://localhost/Identity',
//   client_id: 'pixeltradeuilocal',
//   appURI: 'http://localhost:4200',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };


// server deploy
// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://52.163.92.12/api',
//   authApiURI: 'https://52.163.92.12/Identity',
//   client_id: 'pixeltradeuiip',
//   appURI: 'https://52.163.92.12/app',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };

// on-prem server deploy - ip
// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://122.166.67.4/api',
//   authApiURI: 'https://122.166.67.4/Identity',
//   client_id: 'gammaspottardeuiip',
//   appURI: 'https://122.166.67.4/app',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };

// on-prem server deploy - ip
// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://gammasoftware.spottrade.in/api',
//   authApiURI: 'https://gammasoftware.spottrade.in/Identity',
//   client_id: 'pixeltradeuiip',
//   appURI: 'https://gammasoftware.spottrade.in/app',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };



// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   // pixelTradeApi: 'https://52.163.92.12/api',
//   pixelTradeApi: 'https://pixeltrade.local/api',
//   // pixelTradeApi: 'https://localhost:44322',
//   authApiURI: 'http://pixeltrade.local/Identity',
//   client_id: 'pixeltradeui',
//   appURI: 'http://pixeltrade.local/app',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };

// local iis ui + local iis settings
// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://pixeltrade.local/api',
//   authApiURI: 'https://pixeltrade.local/Identity',
//   client_id: 'pixeltradeui',
//   appURI: 'https://pixeltrade.local/app',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };

// local ui + local iis settings
// export const environment = {
//   production: false,
//   tradeApiUrl: 'https://api.kite.trade',
//   apiVersion: 3,
//   tradeWebSocketUrl: 'wss://ws.kite.trade?api_key=XXXXXXXXXXXX&access_token=XXXXXXXXXXXX&uid=hanuunadadksdsad1111',
//   accessToken: 'XXXXXXXXXXXX',
//   apiKey: 'XXXXXXXXXXXX',
//   pixelTradeApi: 'https://52.163.92.12/api',
//   authApiURI: 'https://52.163.92.12/Identity',
//   client_id: 'pixeltradeuiip',
//   appURI: 'https://52.163.92.12/app',
//   authCallback: '/account/auth-callback',
//   post_logout_redirect_uri: '/account/login',
//   response_type: 'id_token token',
//   scope: 'openid profile email pixeltradeapi.read',
//   silent_redirect_uri: '/silent-refresh.html'
// };



